import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

interface IKeyDriveTab 
{
    children: React.ReactNode;
    icon1?: string | React.ReactElement;
    icon2?: string | React.ReactElement;
    icon3?: string | React.ReactElement;
    label1?: React.ReactNode;
    label2?: React.ReactNode;
    label3?: React.ReactNode;
    onChange?: ((event: React.SyntheticEvent, value: any) => void) | undefined;
    numberOfTabs: number;
}

interface StyledTabProps {
  icon?: string | React.ReactElement;
  iconPosition?: "bottom" | "top" | "end" | "start" | undefined;
  label?: React.ReactNode;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const AntTab = styled((props: StyledTabProps) => <Tab iconPosition="start" disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    color: "#4E82A4",
    font: 'normal normal 600 14px/27px Segoe UI',
    minHeight: '34px',
    '&:hover': {
      backgroundColor: '#E8EFF3',
    },
    '&.Mui-selected': {
      color: '#22638D',
    },

  }),
);

export const KeyDriveTab2: React.FC<IKeyDriveTab> = ({
    children,
    icon1,
    icon2,
    label1,
    label2,
    onChange
}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if(onChange)
      onChange(event, newValue)
    setValue(newValue);
  };

  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

 
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <AntTab icon={icon1} label={label1} {...a11yProps(0)} />
          <AntTab icon={icon2} label={label2} {...a11yProps(1)} />
        </Tabs>
      </Box>
      { children }
    </Box>
  );
}